import { AppstoreAddOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';

import { EmptyState } from 'app/components/pages/Extranet/commons/EmptyState/EmptyState';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';
import { useHotelSpacesTypes } from 'app/hooks/data/useHotelSpacesTypes';

import type { ContactsSectionProps } from '../Contacts.types';

import { SpaceContactCard } from './SpaceContactCard';
import styles from './SpacesContacts.module.scss';
import {
  DEFAULT_SPACE_CONTACT,
  SPACES_CONTACTS_FIELD,
  buildSpaceOptions,
} from './columns';
import type { SpaceContact } from './columns';

export const SpacesContacts = ({
  isEditMode,
  hotelId,
}: ContactsSectionProps) => {
  const { data: hotel } = useGetHotel(hotelId);
  const { data: spaceTypes } = useHotelSpacesTypes();

  const contacts = Form.useWatch<SpaceContact[]>(SPACES_CONTACTS_FIELD) ?? [];

  const spaceOptions = buildSpaceOptions(hotel?.spaces ?? [], spaceTypes ?? []);
  const spaceLabelById = spaceOptions.reduce<Record<number, string>>(
    (acc, option) => {
      acc[option.value] = option.label;

      return acc;
    },
    {}
  );

  return (
    <div className={styles.container}>
      <Form.List name={SPACES_CONTACTS_FIELD}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <SpaceContactCard
                key={field.key}
                isEditMode={isEditMode}
                displayIndex={index}
                namePath={field.name}
                contact={contacts[field.name]}
                spaceOptions={spaceOptions}
                spaceLabelById={spaceLabelById}
                onRemove={() => remove(field.name)}
                canRemove={isEditMode}
              />
            ))}
            {!isEditMode && fields.length === 0 && (
              <EmptyState
                icon={<AppstoreAddOutlined />}
                title="No contact"
                description="No contact has been added yet for a specific space (spa, restaurant, etc.)"
              />
            )}
            {isEditMode && (
              <Button
                className={styles.addButton}
                icon={<PlusOutlined />}
                onClick={() => add(DEFAULT_SPACE_CONTACT)}
              >
                Add contact
              </Button>
            )}
          </>
        )}
      </Form.List>
    </div>
  );
};
